import { create } from 'zustand';

export type ToastKind = 'info' | 'success' | 'error';

export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
  action?: { label: string; run: () => void };
}

interface ToastState {
  toasts: Toast[];
  show(message: string, kind?: ToastKind, action?: Toast['action'], durationMs?: number): number;
  dismiss(id: number): void;
  update(id: number, message: string): void;
}

let seq = 0;

export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],
  show(message, kind = 'info', action, durationMs = 4000) {
    const id = ++seq;
    set({ toasts: [...get().toasts.slice(-3), { id, kind, message, action }] });
    if (durationMs > 0) setTimeout(() => get().dismiss(id), durationMs);
    return id;
  },
  update(id, message) {
    set({ toasts: get().toasts.map((t) => (t.id === id ? { ...t, message } : t)) });
  },
  dismiss(id) {
    set({ toasts: get().toasts.filter((t) => t.id !== id) });
  },
}));

export const toast = {
  info: (m: string, action?: Toast['action']) => useToasts.getState().show(m, 'info', action),
  success: (m: string) => useToasts.getState().show(m, 'success'),
  error: (m: string) => useToasts.getState().show(m, 'error', undefined, 6000),
};
